import { render, staticRenderFns } from "./Yelp.vue?vue&type=template&id=b2db646a&scoped=true&"
import script from "./Yelp.vue?vue&type=script&lang=js&"
export * from "./Yelp.vue?vue&type=script&lang=js&"
import style0 from "./Yelp.vue?vue&type=style&index=0&id=b2db646a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2db646a",
  null
  
)

export default component.exports